import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = {
  key: 0,
  class: "stages scroll-wrapper"
}
const _hoisted_5 = { class: "stages-header" }
const _hoisted_6 = {
  key: 0,
  class: "items-count"
}
const _hoisted_7 = {
  key: 1,
  class: "items-count"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "stage-row" }
const _hoisted_10 = { class: "stage-title-wr" }
const _hoisted_11 = { class: "stage-title" }
const _hoisted_12 = { class: "table-scroll" }
const _hoisted_13 = { class: "table-default" }
const _hoisted_14 = { class: "checkbox" }
const _hoisted_15 = { class: "lot-number" }
const _hoisted_16 = { class: "stage-number" }
const _hoisted_17 = { class: "size" }
const _hoisted_18 = { class: "price" }
const _hoisted_19 = {
  key: 1,
  class: "spinner"
}
const _hoisted_20 = { class: "controls" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    classes: "share-lots-modal height-limited"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.props.type === "leads"? "Choose the lot"
: "Choose lots to attach this file"), 1),
          _createVNode($setup["InputSearch"], {
            class: "search",
            modelValue: $setup.searchQuery,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
            placeholder: "Search",
            theme: "filter"
          }, null, 8, ["modelValue"])
        ]),
        (!$setup.loadingLots)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                ($setup.selectedLots.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.plural($setup.selectedLots.length, "lot")) + " selected", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.plural($setup.lots.length, "lot")), 1))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", {
                    class: "stage-row-wrapper",
                    onClick: ($event: any) => ($setup.onLotRow(index))
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode($setup["CheckboxInput"], {
                        disabled: $setup.props.type === 'leads',
                        class: _normalizeClass({ hide: $setup.props.type === 'leads' }),
                        checkedPartial: $setup.getStageCheckedPartial(index),
                        modelValue: $setup.getStageModelValue(index),
                        "onUpdate:modelValue": ($event: any) => ($setup.selectAll($event, index)),
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8, ["disabled", "class", "checkedPartial", "modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, "Stage " + _toDisplayString(stage.title), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["chevron", { rotated: !$setup.activeStagesIndex[index] }])
                        }, null, 2)
                      ])
                    ])
                  ], 8, _hoisted_8),
                  _createElementVNode("div", {
                    class: _normalizeClass(["wrapper-table", { opened: $setup.activeStagesIndex[index] }]),
                    ref_for: true,
                    ref: (el) => { if (el) { $setup.tableRefs[index] = el; } }
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("table", _hoisted_13, [
                        _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "checkbox checkbox--wide" }),
                            _createElementVNode("th", { class: "lot-number" }, "Lot No."),
                            _createElementVNode("th", { class: "stage-number" }, "Stage"),
                            _createElementVNode("th", { class: "size" }, [
                              _createTextVNode("Size, m"),
                              _createElementVNode("sup", null, "2")
                            ]),
                            _createElementVNode("th", { class: "price" }, "Price")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedLots[index], (lot, idx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: idx,
                              class: _normalizeClass({ disabled: $setup.isLotRowDisabled(index, idx) })
                            }, [
                              _createElementVNode("td", _hoisted_14, [
                                _createVNode($setup["CheckboxInput"], {
                                  disabled: $setup.isLotRowDisabled(index, idx),
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                                  modelValue: $setup.getLotModelValue(index, idx),
                                  "onUpdate:modelValue": ($event: any) => ($setup.selectLot($event, index, lot.lotId))
                                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", _hoisted_15, _toDisplayString(lot.lotTitle), 1),
                              _createElementVNode("td", _hoisted_16, "Stage " + _toDisplayString(lot.stageTitle), 1),
                              _createElementVNode("td", _hoisted_17, _toDisplayString($setup.formatPrice(lot.lotSize, false)), 1),
                              _createElementVNode("td", _hoisted_18, _toDisplayString($setup.formatPrice(lot.lotPrice)), 1)
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 2)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19)),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            class: "button default",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button default primary send",
            onClick: $setup.send,
            disabled: !$setup.selectedLots.length
          }, _toDisplayString($setup.props.type === "leads" ? "Send" : "Done"), 9, _hoisted_21)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}